import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Components as RadioComponents } from './radio.style';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
export const Standard = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      checked = false,
      error = false,
      disabled = false,
      label,
      hint,
      fit = 'medium',
      required,
      tooltipDescription,
      tooltipDescriptionPosition = 'right'
    } = props,
    restProps = __rest(props, ["checked", "error", "disabled", "label", "hint", "fit", "required", "tooltipDescription", "tooltipDescriptionPosition"]);
  return _jsxs(_Fragment, {
    children: [_jsxs(RadioComponents.Container, _extends({
      disabled: disabled
    }, {
      children: [_jsxs(RadioComponents.RadioButton, {
        children: [_jsx(RadioComponents.HiddenRadio, _extends({
          checked: checked,
          disabled: disabled,
          ref: ref
        }, restProps)), _jsx(RadioComponents.StyledRadio, {
          error: error,
          checked: checked,
          disabled: disabled,
          fit: fit
        })]
      }), label && _jsxs(RadioComponents.Label, _extends({
        variant: "body1",
        fontStyle: "normal",
        fit: fit
      }, {
        children: [label, required && _jsx("span", {
          className: "required"
        })]
      })), !!tooltipDescription && _jsx(RadioComponents.LabelToolTip, {
        children: _jsx(Tooltip, _extends({
          fit: fit,
          content: tooltipDescription,
          width: 'auto',
          position: tooltipDescriptionPosition,
          appearance: "default"
        }, {
          children: _jsx(Icon, {
            name: "info-circle",
            size: fit === 'large' ? '24' : '20'
          })
        }))
      })]
    })), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, restProps)), hint && _jsx(Hint, _extends({
      hint: hint,
      fit: fit
    }, restProps))]
  });
});